import { render, staticRenderFns } from "./recomedcontribute.vue?vue&type=template&id=68cb22d6&scoped=true"
import script from "./recomedcontribute.vue?vue&type=script&lang=js"
export * from "./recomedcontribute.vue?vue&type=script&lang=js"
import style0 from "./recomedcontribute.vue?vue&type=style&index=0&id=68cb22d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb22d6",
  null
  
)

export default component.exports